import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

import { Spinner } from '@admin/components/spinner';
import { facilitiesURL } from '@admin/config/routes';
import { client } from '@admin/libraries/apollo';
import { useDepotSiteRedirectQuery, useWarehouseQuery } from '@admin/schema';

import { LinkedFacilityRedirect } from './linked_facility_redirect';

export const RedirectToFacilitiesList: React.FC = () => <Redirect to={facilitiesURL()} />;

export const RedirectToCreateFacility: React.FC = () => <Redirect to={`${facilitiesURL()}/new`} />;

export const WarehouseSiteRedirect: React.FC = () => {
  const { id, warehouseID } = useParams<{ id?: string; warehouseID?: string }>();
  const siteId = warehouseID ?? id;
  const { data, loading } = useWarehouseQuery({ client, variables: { id: siteId! }, skip: !siteId });

  if (!siteId) {
    return <Redirect to={facilitiesURL()} />;
  }

  if (loading && !data) {
    return <Spinner />;
  }

  const facilityID = data?.warehouse?.facilityID;
  if (facilityID) {
    return <LinkedFacilityRedirect facilityID={facilityID} />;
  }

  return <Redirect to={facilitiesURL()} />;
};

export const DepotSiteRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useDepotSiteRedirectQuery({ client, variables: { id: id! }, skip: !id });

  if (!id) {
    return <Redirect to={facilitiesURL()} />;
  }

  if (loading && !data) {
    return <Spinner />;
  }

  const facilityID = data?.depot?.facilityID;
  if (facilityID) {
    return <LinkedFacilityRedirect facilityID={facilityID} />;
  }

  return <Redirect to={facilitiesURL()} />;
};
